import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from '../table.module.scss';
const cx = classnames.bind(styles);

export default class DataCell extends PureComponent {
  static propTypes = {
    cellRenderer: PropTypes.func,
    row: PropTypes.number.isRequired,
    col: PropTypes.number.isRequired,
    colSpan: PropTypes.number,
    rowSpan: PropTypes.number,
    width: PropTypes.string,
    overflow: PropTypes.oneOf(['wrap', 'nowrap', 'clip']),
    selected: PropTypes.bool.isRequired,
    editing: PropTypes.bool.isRequired,
    onMouseDown: PropTypes.func.isRequired,
    onDoubleClick: PropTypes.func.isRequired,
    onMouseOver: PropTypes.func.isRequired,
    onContextMenu: PropTypes.func.isRequired,
    onRef: PropTypes.func.isRequired,
    onRefRemove: PropTypes.func.isRequired,
    updated: PropTypes.bool,
    attributes: PropTypes.object,
  };

  static defaultProps = {
    cellRenderer: null,
  };

  constructor(props) {
    super(props);
    this.state = { updated: false };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ updated: true });
      this.timeout = setTimeout(() => this.setState({ updated: false }), 700);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.editing === true &&
      this.props.editing === false &&
      this.props.reverting === false
    ) {
      this.onChange(this._input.value);
    }
    if (prevProps.editing === false && this.props.editing === true) {
      if (this.props.clear) {
        this._input.value = '';
      } else {
        this._input.value =
          this.props.data === null ? this.props.value : this.props.data;
      }
      this._input.focus();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  onChange(value) {
    const initialData =
      this.props.data === null ? this.props.value : this.props.data;
    (value === '' || initialData !== value) &&
      this.props.onChange(this.props.row, this.props.col, value);
  }

  render() {
    const {
      cellRenderer: CellRenderer,
      row,
      col,
      rowSpan,
      colSpan,
      readOnly,
      width,
      overflow,
      value,
      className,
      editing,
      selected,
      attributes,
      onMouseDown,
      onMouseOver,
      onDoubleClick,
      onContextMenu,
      onRef,
    } = this.props;
    const style = { width };

    const cellContent = (
      <span
        className={cx('cell-content')}
        key="cell-content"
        style={{ display: editing && selected ? 'none' : 'block' }}
      >
        {value}
      </span>
    );

    const inputField = (
      <input
        className={cx('cell-input')}
        key="cell-input"
        style={{ display: editing && selected ? 'block' : 'none' }}
        ref={input => {
          this._input = input;
        }}
      />
    );

    return (
      <td
        {...{ 'data-selected': selected ? true : null }}
        ref={ref => onRef({ row, col, ref })}
        className={`${cx(
          'table-cell',
          overflow,
          { selected },
          { editing },
          { readOnly },
          { updated: this.state.updated },
        )} ${className}`}
        onMouseDown={() => onMouseDown(row, col)}
        onDoubleClick={() => onDoubleClick(row, col)}
        onMouseOver={() => onMouseOver(row, col)}
        onContextMenu={e => onContextMenu(e, row, col)}
        colSpan={colSpan || 1}
        rowSpan={rowSpan || 1}
        style={style}
        {...attributes}
      >
        {CellRenderer ? (
          <CellRenderer {...this.props}>
            {[cellContent, inputField]}
          </CellRenderer>
        ) : (
          [cellContent, inputField]
        )}
      </td>
    );
  }
}
